import React from 'react';

// Components
import * as S from './Styled';
import Icon from '../../Icon';
import Counter from '../../Counter';
import Alert from '../../Alert';
import CountryFlag from '../../CountryFlag';
import { useTranslation } from 'react-i18next';
import {
  isDivisible,
  getTheNumberOfParts,
  getQuantity,
  getProductPositionData,
  isAnIndivisible,
} from '../../../utils/cart';

// Utils
import { getOr, getUserType } from '../../../utils';
import _round from 'lodash/round';
import { useLang } from '../../../context/lang';
import i18n from '../../../i18n';

export const info = (obj, isInsuranceAgent) => {
  const { in_cart, pack_info } = obj;
  const pack = pack_info.unit_name ?? 'package';
  return in_cart > 1
    ? isDivisible(pack_info)
      ? getProductPositionData(obj, isInsuranceAgent)
      : `${in_cart} ${i18n.t(`labels.${pack}`, {
          count: parseFloat(in_cart),
        })}`
    : null;
};

export const price = obj => {
  const packinfo = obj?.pack_info;
  let quantity = packinfo ? obj.in_cart / packinfo.quantity_unit_in_pack : null;
  let value = isDivisible(packinfo)
    ? quantity * obj.online_price
    : obj.in_cart * obj.online_price;

  return `${_round(value, 2)} ₴`;
};

const Item = ({ product }) => {
  const { t } = useTranslation();
  let pack = getOr(product, 'pack_info.unit_name', 'package');
  let user = getUserType();
  let isInsuranceAgent = user === 'insurance';
  const { language } = useLang();

  return (
    <>
      {product.in_cart >= product.quantity ? (
        <Alert warning>{t('labels.the_maximum_amount_of_merchandise')}</Alert>
      ) : null}
      {product.notAdded ? (
        <Alert error>
          {t('labels.an_item_with_a_quantity_of_0_was_detected')}
        </Alert>
      ) : null}
      <S.Item>
        <S.Pic>
          <img
            src={
              product.image_url && product.image_url.length
                ? `${product.image_url}?w=120&h=120&q=90`
                : '/img/no_photo.jpg?w=120&h=120&q=90'
            }
            alt={
              product.image_url && product.image_url.length
                ? product.name
                : 'Нет фото'
            }
          />
        </S.Pic>
        <S.Wrapper>
          <S.Description onClick={() => product.onShow(product._id)}>
            <S.Title>{product[`name_${language}`]}</S.Title>
            <S.Text>
              <S.Producer>
                <CountryFlag code={product.goods_producer.country_code} space />
                {product.goods_producer.name}
              </S.Producer>
            </S.Text>
            {product?.nds && isInsuranceAgent ? (
              <S.Text>
                {t('labels.vat')}: {`${product?.nds} %`}
              </S.Text>
            ) : null}
          </S.Description>
          <S.Packaging>
            <S.NumPackages>
              <S.Label>
                {t('labels.quantity')} {t('labels.package', { count: 5 })}
              </S.Label>
              <S.Counter>
                <Counter
                  value={product.in_cart > 0 ? getQuantity(product) : 0}
                  name="qty"
                  onChange={product.changeCount}
                  increase={product.addOne}
                  decrease={product.removeOne}
                  max={product.quantity}
                  pack_info={product.pack_info}
                  isInsuranceAgent={isInsuranceAgent}
                />
              </S.Counter>
            </S.NumPackages>
            {isDivisible(product.pack_info) &&
            !isAnIndivisible(product.pack_info) ? (
              <S.NumParts>
                <S.Label>
                  {t('labels.quantity')} {t(`labels.${pack}`, { count: 9999 })}
                </S.Label>
                <S.Counter>
                  <Counter
                    value={
                      product.in_cart > 0 ? getTheNumberOfParts(product) : 0
                    }
                    name="unit_qty"
                    onChange={product.changeCount}
                    increase={product.addOnePart}
                    decrease={product.removeOnePart}
                    max={product.pack_info.quantity_unit_in_pack}
                    pack_info={product.pack_info}
                    isInsuranceAgent={isInsuranceAgent}
                  />
                </S.Counter>
              </S.NumParts>
            ) : null}
          </S.Packaging>
          <S.Amount>
            <S.Label>{t('labels.sum')}</S.Label>
            <S.Total>
              {t('labels.of')} {price(product, isInsuranceAgent)}
            </S.Total>
            <S.Content>{info(product)}</S.Content>
          </S.Amount>
          <S.Edit onClick={() => product.onRemove(product.id)}>
            <Icon name="trash" />
          </S.Edit>
        </S.Wrapper>
      </S.Item>
    </>
  );
};

export default Item;
